import { customInstance } from './custom-instance';

export type AdhocQuestion = {
  type: string;
  questionText: string;
  translatedQuestionText?: string;
  answer?: string;
  uniqueId: string;
  answeredAt?: string;
};

export type RetrieveAdhocMessagesResponse = {
  visitId: number;
  messageId: number;
  uniqueId: string;
  adHocQuestions: AdhocQuestion[];
};

export type UpdateAdhocAnswer = {
  uniqueId: string;
  answer: string;
};

export type UpdateAdhocMessagesRequest = {
  adHocQuestions: UpdateAdhocAnswer[];
};

export type UpdateAdhocMessagesResponse = {
  visitId: number;
  updatedCount: number;
  patientUpdatedAt?: string;
};

export type SendAdhocMessagesRequest = {
  recipientAddress: string;
  uniqueId: string;
  adHocQuestions: AdhocQuestion[];
  messageSummary?: string;
  contentDetails?: string[];
};

export type SendAdhocMessagesResponse = {
  visitId: number;
  messageId: number;
  uniqueId: string;
  appendedQuestionCount: number;
};

export type RetrievePatientMessageResponse = {
  id: number;
  uniqueId: string;
  contentType: string;
  messageContent: Record<string, string>;
  isExpired: boolean;
  expiresAt?: string;
  createdAt: string;
};

export function retrieveAdhocMessages(uniqueId: string) {
  return customInstance<RetrieveAdhocMessagesResponse>(
    {
      url: `/patient-messages/adhoc/${uniqueId}`,
      method: 'GET',
    },
    undefined,
  );
}

export function retrievePatientMessage(uniqueId: string) {
  return customInstance<RetrievePatientMessageResponse>(
    {
      url: `/patient-messages/retrieve/${uniqueId}`,
      method: 'GET',
    },
    undefined,
  );
}

export function updateAdhocMessages(visitId: number, data: UpdateAdhocMessagesRequest) {
  return customInstance<UpdateAdhocMessagesResponse>(
    {
      url: `/patient-messages/adhoc/${visitId}`,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
    undefined,
  );
}

export function sendAdhocMessagesByVisitId(visitId: number, data: SendAdhocMessagesRequest) {
  return customInstance<SendAdhocMessagesResponse>(
    {
      url: `/patient-messages/adhoc/${visitId}/send`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    },
    undefined,
  );
}
